module.exports = __webpack_public_path__ + "img/people-pants-simple.5e05b96e.svg";